export { default } from './LoaderSVG'
